export const HISTORY_API_DOMAIN = `${import.meta.env.VITE_DEPLOY_TARGET === "production" ? "https://flare.space/api/" : "https://flare-space-test.matheo.si/api/"}`;

export const P_CHAIN_INDEXER_DOMAIN = "https://p.indexers.flare.space/";

export const FLARE_SPACE_DOMAIN = "https://flare.space";
export const GA_TRACKING_ID = "G-7YE516EVDL";
export const COOKIE_CONNECT_WALLET = "flare_space_connectWallet";
